import { Flex } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import type { Goal as GoalModel } from '@feathr/blackbox';
import { Button, InlineEdit } from '@feathr/components';
import { useGoalContext } from '@feathr/extender/components/Goal';
import { getIconForAction } from '@feathr/hooks';

import * as styles from './GoalHeading.css';

interface IProps {
  goal: GoalModel;
}

function GoalHeading({ goal }: Readonly<IProps>): JSX.Element {
  const { handleRemove } = useGoalContext();

  return (
    <Flex align={'center'} direction={'row'} justify={'space-between'}>
      <InlineEdit attribute={'name'} className={styles.title} model={goal} />
      <Button onClick={(): void => handleRemove(goal)} type={'icon-small'}>
        {getIconForAction('close')}
      </Button>
    </Flex>
  );
}

export default observer(GoalHeading);
